import { styled } from '@mui/material/styles';

export const Container = styled('div')({});

export const Item = styled('div')(({ theme }) => ({
  position: 'relative',
  padding: '0px 0 5px 15px',
  '&:after': {
    content: '""',
    width: 1,
    height: '90%',
    display: 'block',
    position: 'absolute',
    top: 4,
    left: 3,
    bottom: 0,
    borderLeft: `0.5px dashed ${theme.palette.color.blackSecondary}`,
  },
}));

export const Text = styled('div')(({ theme }) => ({
  fontFamily: 'AvenirNext-DemiBold',
  fontSize: 12,
  color: theme.palette.color.blackMain,
}));

export const Circle = styled('div')(({ theme }) => ({
  width: 7,
  height: 7,
  display: 'inline-block',
  backgroundColor: theme.palette.color.blackSecondary,
  borderRadius: '50%',
  position: 'absolute',
  top: 4,
  left: 0,
  margin: 'auto',
  zIndex: 1,
}));

export const getStyles = (theme) => ({
  header: {
    display: 'flex',
  },
  date: {
    fontSize: '10px',
    display: 'block',
    marginTop: '5px',
  },
  contentWrapper: {
    overflow: 'hidden',
    width: '100%',
    textAlign: 'left',
  },
  noteWrapper: {
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: '3px',
    padding: '7px 10px',
  },
  showLink: {
    fontFamily: 'AvenirNext',
    fontSize: '11px',
    color: theme.palette.primary.main,
    cursor: 'pointer',
    fontWeight: 'bold',
    width: '100%',
  },
  content: {
    fontFamily: 'AvenirNext',
    fontSize: '11px',
    fontWeight: 'bold',
    color: theme.palette.color.blackSecondary,
    whiteSpace: 'pre-line',
  },
  editBtn: {
    fontFamily: 'AvenirNext-DemiBold',
    border: `solid 0.5px ${theme.palette.color.grayTwelfth}`,
    background: theme.palette.color.white,
    borderRadius: '1.5px',
    padding: '2px 12px',
    color: theme.palette.color.grayTwelfth,
    fontSize: '10px',
    marginLeft: '5px',
    cursor: 'pointer',
  },
  btnWrapper: {
    minWidth: '101px',
    textAlign: 'right',
  },
});
